const RomanianPackage = {
    //header
    PAGETITLE: "Platforma voluntarilor - Filiala Sector 6",
    //
    MENU: "Meniu",
    USERNAME: "Utilizator",
    PASSWORD: "Parola",
    //sidemenu
        //users
    USERS: "Utilizatori",
    CANDIDATES: "Candidati",
    VOLUNTEERS: "Voluntari",
    COORDINATORS: "Coordonatori",
    RECRUITORS: "Recrutori",
    ADMINS: "Admini",
    GROUP_MANAGEMENT: "Gestionare grupuri",
        //activities
    ACTIVITIES: "Activitati",
    PAST_ACTIVITIES: "Activitati trecute",
    FUTURE_ACTIVITIES: "Activitati viitoare",
    VALIDATE_PRESENCE: "Validare",
        //
    ANNOUNCEMENTS: "Anunturi",
    COURSES: "Cursuri",
    REPORTS: "Rapoarte",
    //default view
    WELCOME_MESSAGE: "Bine ai venit pe pagina de administrare a bazei de date a Crucii Rosii Sector 6.",
    //buttons
    VIEW: "Vizualizare",
    ADD: "Adaugare",
    CREATE: "Creare",
    EDIT: "Editare",
    MODIFY: "Modificare",
    DELETE: "Stergere",
    SUBMIT: "Trimitere",
    TRANSFORM_INTO_VOLUNTEER: "Voluntar",
    GENERATE: "Generare",
    TIME_VALIDATION: "Validare ore",
    CLOSE_ACTIVITY: "Inchide",
    VOLUNTEERS_ALLOCATION: "Alocare voluntari",
    TRANSFORM_INTO_ACTIVITY: "Transformare in activitate",
    //react-table 
    PREVIOUS_TEXT: 'Inapoi',
    NEXT_TEXT: 'Inainte',
    LOADING_TEXT: 'Se incarca',
    NO_DATA_TEXT: 'Nu exista date',
    PAGE_TEXT: 'Pagina',
    OF_TEXT: 'din',
    ROWS_TEXT: 'randuri',

};

export default RomanianPackage;


// WEBPACK FOOTER //
// ./src/languages/RomanianPackage.js